<ng-container>
    <div class="modal-header">
        <button type="button" class="close" (click)="closeModal()" aria-label="Close">&times;</button>
    </div>
    <div class="modal-body">
        <h3>{{ "MODAL.SELECT_COLUMNS_TO_EXPORT" | translate }}</h3>
        <div class="my-2 row">
            <!-- crea -->
            <div class="col-12 d-flex" *ngIf="!selectedTemplate && column2.length > 0">
                <input type="text" class="form-control flex-basis-50" [(ngModel)]="newExportTemplateName" [placeholder]="'EXPORT_TEMPLATE_NAME' | translate">
                <button class="btn btn-outline-primary mx-1" (click)="saveTemplate()" [disabled]="newExportTemplateName.length < 1">{{ "SAVE" | translate }}</button>
                <button class="btn btn-outline-danger" *ngIf="column2.length > 0" (click)="clean()">{{ "RESET" | translate }}</button>
            </div>
            <!-- modifica -->
            <div class="col-12 d-flex" *ngIf="(selectedTemplate || column2.length < 1) && templatesList.length > 0">
                <ng-select class="flex-basis-50" bindLabel="name" [items]="templatesList" [clearable]="true" [multiple]="false" (change)="loadTemplate()" [(ngModel)]="selectedTemplate"
                           [placeholder]="'SELECT_EXPORT_TEMPLATE' | translate"></ng-select>
                <button class="btn btn-outline-secondary ml-1" (click)="editTemplate()" *ngIf="selectedTemplate && selectedTemplate.columns.toString() !== column2.toString()">{{ "EDIT" | translate }}</button>
                <button class="btn btn-outline-danger ml-1" (click)="deleteTemplate()" *ngIf="selectedTemplate">{{ "DELETE" | translate }}</button>
            </div>
        </div>
        <div class="row" id="columns-container" cdkDropListGroup>
            <div *ngFor="let column of [column1, column2]; let i = index" class="col-md-6 column" cdkDropList
                 [id]="'column' + (i + 1)" [cdkDropListData]="column" (cdkDropListDropped)="drop($event)">
                <h5>{{ (i === 0 ? 'SLECTABLE_COLUMNS' : 'SELECTED_COLUMNS') | translate }}</h5>
                <div class="list-group">
                    <ng-container *ngFor="let label of labels; let i2 = index">
                        <ng-container *ngIf="column.includes(label)">
                            <label cdkDrag class="list-group-item list-group-item-action cursor-grab"
                                   [style.order]="column2.indexOf(label)" (click)="moveLabel(label)">
                                <i [data-feather]="i === 0 ? 'plus' : 'minus'" size="16" class="mr-50"
                                   [class]="i === 0 ? 'custom-icon-plus-color' : 'custom-icon-minus-color'"></i>
                                <span>{{ translations[label] || label }}</span>
                            </label>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="i === 1 && column2.length < 1">
                        <p class="pt-1 pl-1">{{ 'NO_SELECTED_FIELDS' | translate }}</p>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer justify-content-between">
        <button type="submit" class="btn btn-outline-secondary" (click)="selectAllColumns()">
            {{ "MODAL.SELECT_ALL_COLUMNS" | translate }}
        </button>
        <button type="submit" class="btn btn-primary" (click)="export()" *ngIf="column2.length > 0">
            {{ "EXPORT_EXCEL" | translate }}
        </button>
    </div>
</ng-container>